import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const QuestionIcon = ({
  title = 'Question',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm21.517 0a9.517 9.517 0 1 0-19.034 0 9.517 9.517 0 0 0 19.034 0Zm-9.37-6.207c-1.548 0-2.985.635-3.939 1.75-.557.653-.41 1.435.195 1.952.56.478 1.354.596 1.777.09.475-.566 1.067-.879 1.72-.879.625 0 .876.207.876.53 0 .168-.111.328-.411.564l-.125.095-.547.396c-.893.668-1.333 1.297-1.333 2.289 0 .67.229 1.269.654 1.735.32.351.875.295 1.546.042.235-.088.46-.198.625-.303.1-.064.178-.128.239-.198.145-.172.203-.412.02-.614l-.043-.043a.592.592 0 0 1-.161-.388c0-.249.138-.455.504-.754l.152-.119c.049-.038.111-.084.27-.201 1.271-.874 1.838-1.596 1.838-2.915 0-1.824-1.551-3.029-3.857-3.029ZM10.36 16.667a1.77 1.77 0 0 1 1.754-1.754 1.77 1.77 0 0 1 1.755 1.754 1.77 1.77 0 0 1-1.755 1.755 1.77 1.77 0 0 1-1.754-1.755Z"
    />
  </CreateIconComponent>
);

export default QuestionIcon;
